import LegalPageLayout from "./LegalPageLayout";
import StoreBadges from "@/components/echo/StoreBadges";

export default function ProposPage() {
  return (
    <LegalPageLayout
      title="À propos d'Echo"
      subtitle="L'application française nº1 de glow up mental"
      testid="page-propos"
    >
      <section>
        <h2>Notre mission</h2>
        <p>
          Echo est né d&apos;une conviction simple : prendre soin de son mental devrait être aussi
          naturel que prendre soin de son corps. Nous avons créé une application qui rend le
          bien-être mental <strong>plaisant, simple et efficace</strong>.
        </p>
      </section>

      <section>
        <h2>Comment ça marche</h2>
        <p>
          Echo t&apos;accompagne jour après jour à travers un programme personnalisé de 60 jours.
          Tu choisis les outils qui te plaisent — méditation, journal, respirations, affirmations —
          et tu gagnes des récompenses au fur et à mesure de ta progression.
        </p>
        <p>
          En moyenne, les premiers effets du glow up mental se ressentent au bout de 60 jours de
          pratique régulière.
        </p>
      </section>

      <section>
        <h2>Pourquoi Echo</h2>
        <ul>
          <li><strong>Français</strong> — conçu en France, adapté à la culture francophone</li>
          <li><strong>Gamifié</strong> — pour rester motivé au quotidien</li>
          <li><strong>Personnalisé</strong> — tu choisis les outils qui te ressemblent</li>
          <li><strong>Respectueux de ta vie privée</strong> — tes données t&apos;appartiennent</li>
        </ul>
      </section>

      <section>
        <h2>Rejoins l&apos;aventure</h2>
        <p>Télécharge Echo dès maintenant et commence ton glow up mental.</p>
        <div className="mt-6">
          <StoreBadges testidPrefix="about" />
        </div>
      </section>
    </LegalPageLayout>
  );
}
